import { Directive, Input, computed } from '@angular/core';

import { IToteOutcome } from '@frontend/oxygen/core-utils';
import { IMarket, IOutcome, ISportEvent } from '@frontend/oxygen/shared-utils';
import * as _ from 'underscore';

import { FiltersService } from '../../../core/services/filters/filters.service';

@Directive({ standalone: true })
export class ForcastTricastRaceCard {
    @Input() outcomeEntity: IToteOutcome;
    @Input() marketEntity: IMarket;
    @Input() eventEntity: ISportEvent;

    isOutcomeCardAvailable = computed(() => !!(this.outcomeEntity && this.marketEntity && this.eventEntity));
    runnerNumberDisplay = computed(() => this.isNumberNeeded(this.outcomeEntity) && !this.outcomeEntity?.isFavourite);
    outcomeName = computed(() => this.nameWithoutLineSymbol(this.outcomeEntity?.name ?? ''));

    constructor(protected filterService: FiltersService) {}

    private nameWithoutLineSymbol(name: string): string {
        return this.filterService.removeLineSymbol(name);
    }

    private isNumberNeeded(outcome: IOutcome): boolean {
        return _.isUndefined(outcome?.runnerNumber) || (!!outcome.runnerNumber && Number(outcome.runnerNumber) > 0);
    }
}
